
import { Component, Vue } from "vue-property-decorator";
import NotificationComponent from "@/components/Notification.vue";
import { namespace } from "vuex-class";
import MainDrawer from "@/components/drawer/MainDrawer.vue";
import MainHeader from "@/components/header/MainHeader.vue";
import MainFooter from "@/components/footer/MainFooter.vue";
import LoginDialog from "@/components/dialogs/LoginDialog.vue";
import CarrinhoDrawer from "../components/drawer/CarrinhoDrawer.vue";

const Auth = namespace("Auth");

@Component({
  name: "AppMainLayout",
  components: {
    NotificationComponent,
    MainDrawer,
    CarrinhoDrawer,
    MainHeader,
    MainFooter,
    LoginDialog,
  },
})
export default class AppMainLayout extends Vue {
  appName = "";
  homeLink = "/";

  @Auth.Getter
  private isLoggedIn!: boolean;

  @Auth.Action
  private signOut!: (message?: string) => Promise<any>;

  // created() {
  //   if (this.$route.path == "/") {
  //     if (this.isLoggedIn) {
  //       this.$router.push("/home");
  //     } else {
  //       if (this.$route.path == "/") this.$router.push("/home");
  //     }
  //   }
  // }

  mounted() {
    this.appName = "Portal de Pedidos"; // process.env.VUE_APP_APP_NAME;
  }

  efetuarLogoff() {
    this.signOut().then(() => {
      this.$router.push("/home");
    });
  }

  abrirDadosUsuario() {
    this.$router.push("/meusdados");
  }
}
